export default "__VITE_ASSET__B5GI4Cuz__"